<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">求人票チェック {{getSubTitle()}}</h1>
    <span class="close" (click)="close()"></span>
  </div>

  <!-- 種別選択 -->
  <ng-container *ngIf="step === AzCheckStep.SelectCategory">
    <ag-job-az-check-step-select-category #categoryStep></ag-job-az-check-step-select-category>
    <div class="dialog__footer">
      <button class="dialog__button dialog__button--gray" (click)="close()">
        キャンセル
      </button>
      <button
        class="dialog__button dialog__button--green"
        [disabled]="!categoryStep.selectedJobCategory || isLoading"
        (click)="startCheck(categoryStep.selectedJobCategory)"
      >
        {{ isLoading ? 'チェック中...' : 'チェックを開始する' }}
      </button>
    </div>
  </ng-container>

  <!-- チェック結果 -->
  <ng-container *ngIf="step === AzCheckStep.CheckResult">
    <ag-job-az-check-step-result [checkTiming]="'onCreate'"></ag-job-az-check-step-result>
    <div class="dialog__footer">
      <div class="dialog__footer-left">
        <button class="dialog__button dialog__button--gray" (click)="close()">
          キャンセル
        </button>
      </div>
      <div class="dialog__footer-right">
        <button class="dialog__button dialog__button--green" [disabled]="!validity || hasUnsavedChanges" (click)="consult()">
          企画相談
        </button>
        <button class="dialog__button dialog__button--green" [disabled]="!canSendToCompany || !jobAzCheckService.pdfCheckAccepted" (click)="sendToCompany()">
          企業へ送信に進む
        </button>
        <button class="dialog__button dialog__button--blue" [disabled]="!validity || !hasUnsavedChanges" (click)="tempSave()">
          更新して再チェック
        </button>
      </div>
    </div>
  </ng-container>

  <!-- 企業送信 -->
  <ng-container *ngIf="step === AzCheckStep.SendToCompany">
    <ag-job-az-check-step-send-to-company></ag-job-az-check-step-send-to-company>
  </ng-container>

  <!-- 企画相談 -->
  <ng-container *ngIf="step === AzCheckStep.Consultation">
    <ag-job-az-check-step-consultation #consultStep></ag-job-az-check-step-consultation>
    <div class="dialog__footer">
      <div class="dialog__footer-left">
        <button class="dialog__button dialog__button--gray" (click)="close()">
          キャンセル
        </button>
      </div>
      <div class="dialog__footer-right">
        <span class="az-consult__copied" *ngIf="consultStep.copySuccessMessage">コピーしました</span>
        <button class="dialog__button dialog__button--green" (click)="consultStep.copyConsultationDetail('onCreate')">
          企画相談
        </button>
      </div>
    </div>
  </ng-container>
</div>
